<!--
* @program: office_automation 
* @author: ly
* @component:invoiceForm 
* @description: 
* @create: 2021-12-16 09:48
-->
<template>
    <a-page-header
            style="border: 1px solid rgb(235, 237, 240)"
            :title="formData.id?'发票详情':'新建发票'"
    />
    <div v-if="visible" style="display: flex;flex-wrap: wrap;">
        <TagShow :color="'blue'" :tag="'基础信息'">
            <template #content>
                <FcForm style="width:500px" :form-columns="formColumns" v-model:form-data="mFormData" :view-model="viewModel" />
            </template>
        </TagShow>
        <TagShow :color="'cyan'" :tag="'收付款信息'">
            <template #content>
                <FcForm style="width:500px" :form-columns="formColumns1" v-model:form-data="mFormData" :view-model="viewModel" />
            </template>
        </TagShow>
        <TagShow :color="'red'" :tag="'冲红'">
            <template #content>
                <FcForm style="width:500px" :form-columns="formColumns2" v-model:form-data="mFormData" :view-model="viewModel" />
            </template>
        </TagShow>
    </div>
    <a-divider />
    <a-button v-if="!viewModel"  type="primary" @click="saveData">提交</a-button>
</template>

<script>
    import FcForm from "../../../components/form/FcForm";
    import item_invoice_record from "../../../assets/tables/item_invoice_record";
    import TagShow from "../../_components/TagShow";
    import invoiceRecord from "../../../assets/api/invoiceRecord";
    export default {
        name: "invoiceForm",
        props:["formData","viewModel"],
        emits:["refresh"],
        components:{
            FcForm,TagShow
        },
        watch:{
            formData(){
                this.mFormData = {...this.formData};
            },
            viewModel(){
                this.visible = false;
                setTimeout(()=>{
                    this.visible = true;
                })
            }
        },
        data(){
            return{
                mFormData:{},
                table:new item_invoice_record(),
                formColumns:[],
                formColumns1:[],
                formColumns2:[],
                visible:true
            }
        },
        methods:{
            saveData(){
                invoiceRecord.saveOrUpdate.requestPOST(this,this.mFormData,res=>{
                    if(res.data.flag){
                        this.$message.success(res.data.msg);
                        this.$emit("refresh");
                    }
                    else{
                        this.$message.success(res.data.msg)
                    }
                })
            }
        },
        created() {
            this.mFormData = {...this.formData};
            this.formColumns = this.table.getFormColumns().filter(item=>item.group === 0);
            this.formColumns1 = this.table.getFormColumns().filter(item=>item.group === 1);
            this.formColumns2 = this.table.getFormColumns().filter(item=>item.group === 2);
        }

    }
</script>

<style scoped>

</style>